<template>
  <div class="add-user">
    <div id="add-existing-user-modal" class="modal fade"
         tabindex="-1"
         role="dialog" aria-labelledby="addExistingUserModal"
         aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="AddUserModal" class="modal-title">
              Add Existing User
            </h5>
          </div>
          <div class="modal-body">
            <multiselect v-model="selected_user" :close-on-select="true"
                         :options="selectable_users"
                         placeholder="Select a User"
                         track-by="key" label="name"
                         :allow-empty="false" />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-ss-cancel" data-dismiss="modal">
              Close
            </button>
            <button v-if="selected_user" type="button"
                    class="btn btn-ss-standout"
                    @click.prevent="addExistingUser">
              Add User
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    organisation_users: [],
    selected_user: null,
    existing_users: [],
  }),
  computed: {
    selectable_users() {
      const already_assigned_to_customer = _.map(this.existing_users, 'uuid');
      return _.filter(this.organisation_users, organisation_user => !already_assigned_to_customer.includes(organisation_user.uuid));
    },
  },
  beforeMount() {
    this.existing_users = this.customer.users;
  },
  mounted() {
    this.getOrganisationUsers();
  },
  methods: {
    getOrganisationUsers() {
      axios.get(`/api/v1/admin/organisation/${this.customer.organisation.uuid}`).then((response) => {
        this.organisation_users = response.data.data.organisation_users;
      }).catch((error) => {
        this.handleAxiosError(error);
      });
    },
    addExistingUser() {
      const user_uuid = this.selected_user.uuid;
      const customer_uuids = [this.customer.uuid];

      axios.post(`/api/v1/user/${user_uuid}/update-customers`, {
        customer_uuids: customer_uuids,
        without_detaching: true,
        organisation_uuid: this.customer.organisation.uuid,
      }).then(() => {
        EventBus.$emit('user-added', this.selected_user);
        this.selected_user = null;
        $('#add-existing-user-modal').modal('hide');
      }).catch((error) => {
        this.handleAxiosError(error);
      });
    },
  },
};
</script>
